import { render, staticRenderFns } from "./RootCausesPagePrint.vue?vue&type=template&id=5e538782"
import script from "./RootCausesPagePrint.vue?vue&type=script&lang=js"
export * from "./RootCausesPagePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports